<custom-modal
  [(open)]="isOpenModal"
  [header]="'LABELS.VERIFY_YOUR_PHONE'"
  (openChange)="onDecline()"
  [modalClass]="'verification-dashboard'"
>
  <ng-container *ngIf="isFillingFirstStep">
    <div class="f-bold pb-3">{{ "LABELS.PHONE_NUMBER_VERIFICATION_DISCLAIMER" | translate }}</div>
    <form [formGroup]="userForm">
      <input-phone
        [fc]="userForm?.get('phoneNumber')"
        [errors]="errors.phoneNumber"
        [label]="'LABELS.MOBILE_NUMBER'"
        [id]="'phoneNumber'"
        [isShowHelper]="false"
      ></input-phone>
    </form>
    <button
      type="button"
      class="btn btn-primary verify-btn"
      [disabled]="!userForm.get('phoneNumber').value"
      (click)="getVerificationCode()"
    >
      {{ (isVerificationCodeExpired ? "BUTTON.VERIFICATION_CODE" : "BUTTON.VERIFY") | translate }}
    </button>
  </ng-container>

  <ng-container *ngIf="!verifyCompleted && !isFillingFirstStep">
    <div class="f-bold">{{ "LABELS.ENTER_DIGIT" | translate }}</div>
    <span>{{ formattedPhoneNumber }}</span>
    <div class="input-code">
      <ng-container *ngFor="let i of [0, 1, 2, 3, 4, 5]; let first = first">
        <input
          class="code"
          maxlength="1"
          size="1"
          type="number"
          [appFocus]="isOpenModal && first"
          [id]="i"
          inputmode="number"
          (keydown)="onKey($event)"
        />
      </ng-container>
    </div>
    <p class="paragraph">
      <span *ngIf="!invalidCode">{{ "DIDNT_RECEIVE_CODE" | translate }}</span>
      <span *ngIf="invalidCode" class="invalid-verification">{{ "INVALID_VERIFICATION_CODE" | translate }}</span>
      <a href (click)="resend($event)">{{ "BUTTON.RESEND_CODE" | translate }}</a>
    </p>
  </ng-container>

  <ng-container *ngIf="verifyCompleted && !isFillingFirstStep">
    <div class="verify-body">
      <div class="check-icon">
        <img alt="check" src="assets/icons/success.svg" />
      </div>
      <div class="d-flex flex-column">
        <div class="f-bold">{{ "LABELS.MOBILE_WAS_VERIFIED" | translate }}</div>
        <span class="f-bold">{{ formattedPhoneNumber }}</span>
        <span>{{ "LABELS.PHONE_NUMBER_VERIFIED_DESCRIPTION" | translate }}</span>
      </div>
    </div>
  </ng-container>

  <button footer-action type="button" *ngIf="verifyCompleted && !isFillingFirstStep" class="btn btn-secondary" (click)="onConfirm()">
    {{ "BUTTON.CLOSE" | translate }}
  </button>
  <button footer-action type="button" *ngIf="!verifyCompleted && !isFillingFirstStep" class="btn btn-primary" (click)="verifyPhone()">
    {{ "BUTTON.VERIFY" | translate }}
  </button>
</custom-modal>
